import { mediaQueryHOC } from '../../../adapters/helpers/Hooks';
import Icon from '../../Icon/Icon';
import { customModalInterestitalStyles, customStylesInterestitialLegalModal } from '../helpers/ModalConfig';
import Block from '../../../adapters/helpers/Block';
import {SpotlightWaitlistConstants, Constants, CampaignIframeOverlayConstants} from '../../../adapters/helpers/Constants';
import ContentProperty from './ContentProperty';
import Heading from '../../Heading/Heading'
import Button from '../../Button/Button';
import Label from '../../Label/Label';
import Image from '../../Image/Image';
import { CheckboxInput } from '../../Janrain/components'
import { mixtureGraphQL } from '../Service/graphql';
import { mixtureFormRegister, updateTraitsMixtureFormRegister } from '../Service/restapi';
import { filterMethod, interestitialEventPush } from '../helpers/utils';
import { checkPattern, getCookieValue, trim } from '../../../adapters/helpers/Utils';
import OnePageScrollContext from '../../OnePageScroll/OnePageScrollContext';
import { registrationHeader,
    registrationUrl,
    formatUSRegistrationBody,
    formatEURegistrationBody,
    sendMessageUrl,
    sendHeader,
    campaignUrlSpotlight,
    formatMessageBody,
    formatConstestMessageBody,
    validateUserUrl,
    validateUserHeader,
    getValidateUserBody,
    campaignUrl,
    campaignHeader,
    surveyUrl,
    submitionSurveyUrl,
    surveyHeader,
    getFormattedLocale,
    formatWaitlistSurveyBody,
    formatWaitlistTopicBody } from '../../../adapters/model/service/gcs/gcsService';

import getConfig from 'next/config';

export {
    mediaQueryHOC,
    customModalInterestitalStyles,
    customStylesInterestitialLegalModal,
    Icon,
    Block,
    SpotlightWaitlistConstants,
    Constants,
    ContentProperty,
    Heading,
    Button,
    Label,
    Image,
    CampaignIframeOverlayConstants,
    CheckboxInput,
    mixtureGraphQL,
    mixtureFormRegister,
    filterMethod,
    formatEURegistrationBody,
    registrationUrl,
    checkPattern,
    trim,
    interestitialEventPush,
    getCookieValue,
    OnePageScrollContext,
    getConfig,
    registrationHeader,
    formatUSRegistrationBody,
    sendMessageUrl,
    sendHeader,
    campaignUrlSpotlight,
    formatMessageBody,
    formatConstestMessageBody,
    validateUserUrl,
    validateUserHeader,
    getValidateUserBody,
    campaignUrl,
    campaignHeader,
    surveyUrl,
    submitionSurveyUrl,
    surveyHeader,
    getFormattedLocale,
    formatWaitlistSurveyBody,
    formatWaitlistTopicBody,
    updateTraitsMixtureFormRegister
}